/**
 * Offres : limites et fonctions. Seule source des limites de l'application (couche de droits côté API :
 * apps/api/src/domain/entitlements.ts).
 */
export const PLAN_FEATURES = ['editor3d', 'csvImport', 'mcp', 'aiInterpreter', 'bulkLabels'] as const
export type PlanFeature = (typeof PLAN_FEATURES)[number]

/**
 * `items` / `locations` : nombre total d'objets et de rangements (non supprimés) d'un foyer — garde-fou contre
 * les abus et les scripts emballés, très au-dessus d'un usage normal.
 */
export const PLAN_LIMITS = ['photoStorageMb', 'photosPerItem', 'members', 'places', 'householdsPerUser', 'items', 'locations'] as const
export type PlanLimit = (typeof PLAN_LIMITS)[number]

export type PlanLimits = Record<PlanLimit, number>
export type PlanFeatures = Record<PlanFeature, boolean>

export const PLAN_INTERVALS = ['month', 'year'] as const
export type PlanInterval = (typeof PLAN_INTERVALS)[number]

export const SUBSCRIPTION_STATUSES = ['free', 'trialing', 'active', 'past_due', 'canceled', 'comped'] as const
export type SubscriptionStatus = (typeof SUBSCRIPTION_STATUSES)[number]

export const PAYMENT_STATUSES = ['pending', 'paid', 'failed', 'refunded'] as const
export type PaymentStatus = (typeof PAYMENT_STATUSES)[number]
